
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'required-input-email',
	emits: ['change-control'],
	props: {
		control: {
			type: Object,
			required: true
		},
		showInvalidRequiredInput: Boolean,
		dense: Boolean
	},
	data() {
		return {
			isChangeInput: false
		};
	},
	computed: {
		value: {
			get(): string {
				return this.control.value;
			},
			set(value: string) {
				this.isChangeInput = true;
				const payload = {
					type: 'email',
					isValid: this.validateEmail(value),
					value
				};
				this.$emit('change-control', payload);
			}
		},
		showError(): boolean {
			if (this.showInvalidRequiredInput) {
				return !this.validateEmail(this.value);
			}
			return this.isChangeInput && !this.validateEmail(this.value);
		}
	},
	methods: {
		validateEmail(value: string): boolean {
			const re =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(value).toLowerCase());
		}
	}
});
